import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/TruckAppointment/TruckAppointment.css';
import createappointmentimg from '../../../Assets/TruckVisits/Assets-Desktop/create-appointment.svg';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import searchimg from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { trackingBaseURL } from '../../../Services/config/apiGateway';
import { TRUCK_APPOINTMENT_DETAILS_ENDPOINT } from '../../../Services/config/apiEndPoints';

import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';


class TruckAppointment extends Component {
    constructor(props) {
        super(props)
        this.state = {
            search: "",
            searchlength: 0,
            truckdataTemporary: [],
            errorMessage: false,
            truckAppointmentDetails: [],
        }
        this.handlechangeSearchAppointmentNo = this.handlechangeSearchAppointmentNo.bind(this);
    }
    getTruckAppointment = () => {
        ApiCall(
            'GET',
            trackingBaseURL + TRUCK_APPOINTMENT_DETAILS_ENDPOINT + `?user=${'23vkpnadey@gmail.com'}`,

            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',

            },
        ).then((apiData) => {

            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log("in 500");
                    this.setState({ errorMessage: true });
                    this.setState({
                        truckAppointmentDetails: [
                            {
                                "appointmentNumber": "ABC1233",
                                "transactionType": "Import",
                                "slotStart": "1613110942",
                                "slotEnd": "1613110942",
                                "status": "Closed",
                                "gateZone": "A1234",
                                "lineOperator": "ABC1234",
                                "licenseNumber": "Shipping lineOperator",
                                "referenceNumber": "ABC1234",
                                "truckingCompany": "ABC Truckers",
                                "driverLicense": "ABC1234",
                                "containerId": "ABC1234",
                                "containerEquipmentType": "Reefer Hazard",
                                "bookingNumber": "ABC1234",
                                "vesselVisit": "ABC1234"
                            },
                            {
                                "appointmentNumber": "TCS!@#$",
                                "transactionType": "Import",
                                "slotStart": "1613110942",
                                "slotEnd": "1613110942",
                                "status": "Closed",
                                "gateZone": "A1234",
                                "lineOperator": "ABC1234",
                                "licenseNumber": "Shipping lineOperator",
                                "referenceNumber": "ABC1234",
                                "truckingCompany": "ABC Truckers",
                                "driverLicense": "ABC1234",
                                "containerId": "ABC1234",
                                "containerEquipmentType": "Reefer Hazard",
                                "bookingNumber": "ABC1234",
                                "vesselVisit": "ABC1234"
                            },
                            {
                                "appointmentNumber": "ABC1238",
                                "transactionType": "Import",
                                "slotStart": "1613110942",
                                "slotEnd": "1613110942",
                                "status": "Closed",
                                "gateZone": "A1234",
                                "lineOperator": "ABC1234",
                                "licenseNumber": "Shipping lineOperator",
                                "referenceNumber": "ABC1234",
                                "truckingCompany": "ABC Truckers",
                                "driverLicense": "ABC1234",
                                "containerId": "ABC1234",
                                "containerEquipmentType": "Reefer Hazard",
                                "bookingNumber": "ABC1234",
                                "vesselVisit": "ABC1234"
                            },
                            {
                                "appointmentNumber": "ABC1234",
                                "transactionType": "Import",
                                "slotStart": "1613110942",
                                "slotEnd": "1613110942",
                                "status": "Closed",
                                "gateZone": "A1234",
                                "lineOperator": "ABC1234",
                                "licenseNumber": "Shipping lineOperator",
                                "referenceNumber": "ABC1234",
                                "truckingCompany": "ABC Truckers",
                                "driverLicense": "ABC1234",
                                "containerId": "ABC1234",
                                "containerEquipmentType": "Reefer Hazard",
                                "bookingNumber": "ABC1234",
                                "vesselVisit": "ABC1234"
                            },
                            {
                                "appointmentNumber": "ABC1236",
                                "transactionType": "Import",
                                "slotStart": "1613110942",
                                "slotEnd": "1613110942",
                                "status": "Closed",
                                "gateZone": "A1234",
                                "lineOperator": "ABC1234",
                                "licenseNumber": "Shipping lineOperator",
                                "referenceNumber": "ABC1234",
                                "truckingCompany": "ABC Truckers",
                                "driverLicense": "ABC1234",
                                "containerId": "ABC1234",
                                "containerEquipmentType": "Reefer Hazard",
                                "bookingNumber": "ABC1234",
                                "vesselVisit": "ABC1234"
                            },
                            {
                                "appointmentNumber": "ABC1235",
                                "transactionType": "Import",
                                "slotStart": "1613110942",
                                "slotEnd": "1613110942",
                                "status": "Closed",
                                "gateZone": "A1234",
                                "lineOperator": "ABC1234",
                                "licenseNumber": "Shipping lineOperator",
                                "referenceNumber": "ABC1234",
                                "truckingCompany": "ABC Truckers",
                                "driverLicense": "ABC1234",
                                "containerId": "ABC1234",
                                "containerEquipmentType": "Reefer Hazard",
                                "bookingNumber": "ABC1234",
                                "vesselVisit": "ABC1234"
                            },
                            {
                                "appointmentNumber": "ABC1237",
                                "transactionType": "Import",
                                "slotStart": "1613110942",
                                "slotEnd": "1613110942",
                                "status": "Closed",
                                "gateZone": "A1234",
                                "lineOperator": "ABC1234",
                                "licenseNumber": "Shipping lineOperator",
                                "referenceNumber": "ABC1234",
                                "truckingCompany": "ABC Truckers",
                                "driverLicense": "ABC1234",
                                "containerId": "ABC1234",
                                "containerEquipmentType": "Reefer Hazard",
                                "bookingNumber": "ABC1234",
                                "vesselVisit": "ABC1234"
                            },
                        ]
                    });
                }
                else {
                    console.log('I am 200!');
                    console.log(apiData);
                    this.setState({ truckAppointmentDetails: apiData });
                }
            }
        });
    }
    componentDidMount = () => {
        this.getTruckAppointment()
    }
    handleContainer = event => {
        this.state.truckdataTemporary?.find((truckdataStore) => {
            if (truckdataStore?.appointmentNumber === this.state.truckdataTemporary[event]?.appointmentNumber) {
                this.props.history.push({
                    pathname: `/AppointmentDetails/${truckdataStore.appointmentNumber}`,
                    state: truckdataStore
                });
            }
        })
    }

    handlechangeSearchAppointmentNo = (e) => {
        this.setState({
            search: e.target.value,
            searchlength: e.target.value?.length,
            errorMessage: false
        });
    };

    createAppointment = () => {
        this.props.history.push('/CreateAppointment')
    }

    searchAppointment = () => {

        if (this.state.searchlength > 0) {
            const truckdatafilter = this.state.truckAppointmentDetails?.filter(i => i.appointmentNumber.toLowerCase() == this.state.search.toLowerCase())
            this.setState({ truckdataTemporary: truckdatafilter });
            if (truckdatafilter?.length === 0) {
                this.setState({ errorMessage: true });
            }
            else {
                this.setState({ errorMessage: false });
            }
            console.log("inside search function", this.state.truckdataTemporary);
        }
    }

    render() {
        if (this.state.searchlength == 0) {
            this.state.truckdataTemporary = this.state.truckAppointmentDetails;
        }
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.truckAppointmentPageTitle} description={TitleDescription.truckAppointmentPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullTruckAppointment">
                    <div id="csnobox111">
                        <nav class="caacnononavbar">
                            <div className="caacnonavbarname">
                                <small id="nonavc"> Truck Appointment</small>
                            </div>
                            <div id="TruckAppointmentAcceptMobile" className="TruckAppointmentNavbarNameRight">
                                <a onClick={() => this.createAppointment()}><img src={createappointmentimg} class=" mr-1 pb-1" id="adssaveicon" alt="" loading="lazy" />
                                    <small id="adsh1saveEnable" >Create Appointment</small></a>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <>
                            <nav class="TruckAppointmentMobileNavbar">
                                <div className="TruckAppointmentNavbarNameRight">
                                    <a onClick={() => this.createAppointment()}><img src={createappointmentimg} class=" mr-1 pb-1" id="adssaveicon" alt="" loading="lazy" />
                                        <small id="adsh1saveEnable" >Create Appointment</small></a>
                                </div>
                            </nav>
                        </>
                        <div class="notificationmaincardtruckappointment">
                            <div class="concsdivlow111">
                                <div class="csdivlow222">
                                    <input
                                        className="appointmentSearch"
                                        placeholder="Search by Appointment No."
                                        autoComplete="off"
                                        id="secrchInput1"
                                        onChange={this.handlechangeSearchAppointmentNo}
                                        value={this.state.search}
                                    ></input>
                                    <img onClick={this.searchAppointment} id="search_img" src={searchimg} width="16" height="16" />
                                </div>
                            </div>
                            <div id="DataTopDivTruckAppointment">
                                {!this.state.errorMessage ?
                                    (this.state.truckdataTemporary?.map((truckdataTemporary, index) => {
                                        return (
                                            <div class="taaconsdiv1" onClick={() => this.handleContainer(index)}>
                                                <div class="consdiv211" >
                                                    <div class="consdiv3">
                                                        <div class="cardleft1">
                                                            <div class="cardleft11">
                                                                <small id="status">Status :</small>
                                                                <small id="statusvalue">{truckdataTemporary?.status}</small>
                                                            </div>
                                                            <div class="cardleft12">
                                                                <small id="status">Appointment No. :</small>
                                                                <small id="statusvalue">{truckdataTemporary?.appointmentNumber}</small>
                                                            </div>
                                                        </div>
                                                        <div class="cardleft2">
                                                            <div class="cardleft21">
                                                                <small id="status">Slot Start Time :</small>
                                                                <small id="statusvalue">{FormatTimeStamp(truckdataTemporary?.slotStart).timedate}</small>
                                                            </div>
                                                            <div class="cardleft22">
                                                                <small id="status">Slot End Time :</small>
                                                                <small id="statusvalue">{FormatTimeStamp(truckdataTemporary?.slotEnd).timedate}</small>
                                                            </div>
                                                        </div>
                                                        <div class="cardleft3">
                                                            <small id="status">Transaction Type :</small>
                                                            <small id="statusvalue">{truckdataTemporary?.transactionType}</small>
                                                        </div>
                                                    </div>
                                                    <div class="taconsdiv12" >
                                                        <img src={rightarrow} id="rightarrowimg" height="18" width="18" class="" alt="" loading="lazy" />
                                                    </div>
                                                </div>
                                            </div>);
                                    }))
                                    :
                                    <div class="notruckfound1">
                                        <small id="nodatamessage1">No result found</small>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="notifooter01">
                    <Footer />
                </div>
                <div class="notifooter02">
                    <Footer2 />
                </div>
            </div>
        );
    }
}

export default TruckAppointment;